import memberInfoModel from "@/models/memberInfo.model";
import bounsModel from "@/models/bouns.model";
import { login, getMemberInfo, updateMemberInfo, deleteAddress, pointHistory, getConsumptionInfo, joinMember, storeChange, setAccessToken, memberPreDeduct } from "@/services/api.service";
import { getEinvoiceErrorMessage } from "@/utils/einvoice.utils";
import { jwtDecode } from "jwt-decode";

export default {
    namespaced: true,
    state: {
        storeData: {},
        memberInfo: null,
        pointHistoryPage: 0,
        pointHistory: 0,
        consumptionInfo: null
    },
    getters: {
        accessToken: (state) => {
            try {
                return state.storeData?.access_token ?? '';
            } catch (error) {
                console.error(error);
                return '';
            }
        },
        // 取得商店代號
        storeCode: (state, getters, rootState) => {
            try {
                return getters.decodedToken.store_code || rootState.basic.currentStore || '';
            } catch (error) {
                console.error(error);
                return '';
            }
        },
        // 判斷 token 是否過期
        isTokenExpired: (state, getters) => {
            try {
                const expiredAt = getters.decodedToken.exp || 0;
                // 獲取當前日期的 Unix timestamp
                const currentDate = Math.floor(Date.now() / 1000);
                // 如果 token 的過期時間小於當前時間，則 token 已過期
                return expiredAt < currentDate;

            } catch (error) {
                return true;
            }
        },
        // 取得會員在此商店的唯一識別碼
        storeMemberUuid: (state, getters) => {
            try {
                return getters.decodedToken.store_member_uuid ?? '';
            } catch (error) {
                console.error(error);
                return '';
            }
        },
        // 取得使用者名稱
        name: (state) => {
            try {
                return state.memberInfo?.name || '';
            } catch (error) {
                console.error(error);
                return '';
            }
        },
        // 會員等級
        vipLevel: (state) => {
            try {
                return state.memberInfo?.vip_level || 1;
            } catch (error) {
                console.error(error);
                return 1;
            }
        },
        carrier: (state) => {
            try {
                return state.memberInfo?.invoice_carrier || ''
            } catch (error) {
                return null
            }
        },
        npoBan: (state) => {
            try {
                return state.memberInfo?.npo_ban || ''
            } catch (error) {
                return null
            }
        },
        vatNumber: (state) => {
            try {
                return state.memberInfo?.vat_number || ''
            } catch (error) {
                return null
            }
        },
        sVatNumber: (state) => {
            try {
                return state.memberInfo?.s_vat_number || ''
            } catch (error) {
                return null
            }
        },
        memberQrCode: (state, getters) => {
            try {
                return `okmember-${getters.storeMemberUuid}`;
            } catch (error) {
                return '';
            }
        },
        phone: (state, getters) => {
            try {
                if (getters.isLogin) {
                    // Modify By Bryant 2025050201 //
                    //                    return state.memberInfo?.mobile_phone || '未提供手機號碼';
                    return state.memberInfo?.mobile_phone;
                    // Modify By Bryant 2025050201 End //
                }
                // 未登入，顯示空字串
                return '';
            } catch (error) {
                return '';
            }
        },
        // 取得會員電話末三碼（來自 memberInfo.phone）
        telephone: (state) => {
            try {
                return state.memberInfo?.phone ?? '';
            } catch (error) {
                console.error(error);
                return '';
            }
        },
        avatar: (state) => {
            try {
                return state.storeData?.picture ?? ''
            } catch (error) {
                return ''
            }
        },
        isLogin: (state, getters) => {
            try {
                return !getters.isTokenExpired;
            } catch (error) {
                return false;
            }
        },
        totalPoints: (state) => {
            return state.memberInfo?.total_points ?? 0;
        },
        // 取得店家自填電話（之後會需要更新回傳後端資料）
        sPhone: (state) => {
            try {
                return state.memberInfo?.s_phone ?? '';
            } catch (error) {
                console.error(error);
                return '';
            }
        },
        // 取得總獎勵點數（暫不使用，預留未來功能）
        totalRewardPoints: (state) => {
            try {
                return state.memberInfo?.total_reward_points ?? 0;
            } catch (error) {
                console.error(error);
                return 0;
            }
        },
        pointHistoryList: (state) => {
            if (!state.pointHistory || state.pointHistory.total_count === 0) return []
            return state.pointHistory.point_report_list
        },
        isStoreMember(state, getters) {
            try {
                return getters.decodedToken.is_store_member || false;
            } catch (e) {
                console.log(e);
                return false;
            }
        },
        // 解碼 JWT token
        decodedToken(state, getters) {
            try {
                return jwtDecode(getters.accessToken) || {};
            } catch (e) {
                console.log(e);
                return {};
            }
        }
    },
    mutations: {
        setCarrier(state, carrier) {
            state.carrier = carrier;
        },
        setNpoBan(state, npoBan) {
            state.npoBan = npoBan ? npoBan : null;
        },
        setMemberInfo(state, memberInfo) {
            state.memberInfo = memberInfo;
        },
        // 更新會員紅利積分總點數（扣點後同步）
        setMemberTotalPoints(state, points) {
            if (state.memberInfo) {
                state.memberInfo = { ...state.memberInfo, total_points: points };
            }
        },
        setStoreData(state, storeData) {
            state.storeData = storeData;
        },
        setPointHistoryPage(state, pointHistoryPage) {
            state.pointHistoryPage = pointHistoryPage
        },
        setPointHistory(state, pointHistory) {
            state.pointHistory = pointHistory
        },
        setConsumptionInfo(state, consumptionInfo) {
            state.consumptionInfo = consumptionInfo
        }
    },
    actions: {
        async fetchMemberInfo({ state, commit }) {
            try {
                const res = (await getMemberInfo()).data.data
                commit('setMemberInfo', { ...state.memberInfo, ...new memberInfoModel(res) })
                console.log('fetch member info res', state.memberInfo)
            } catch (error) {
                commit('setMemberInfo', {})
                throw (error)
            }
        },
        // 訂單成立後預扣紅利積分
        async preDeductPoints({ commit }, { orderNumber, decrease, comment }) {
            const res = await memberPreDeduct({
                order_number: orderNumber,
                decrease: Number(decrease),
                comment: comment || '線上點餐紅利積分折抵'
            })
            const data = res?.data?.data
            if (data?.msg !== 'Success') {
                throw new Error(data?.err_msg || '紅利積分扣除失敗')
            }
            // 以後端回傳餘額更新 total_points
            commit('setMemberTotalPoints', data.member_total_points)
            return data
        },
        // API 已改為部分更新：只送出呼叫端指定的欄位，沒帶的 key 後端不動
        // 不再合併 state.memberInfo，避免誤送 invoice_carrier 觸發光貿載具驗證
        async updateMemberInfo({ dispatch }, data) {
            const res = await updateMemberInfo(data)
            const responseData = res?.data?.data
            if (responseData?.msg === 'Failed') {
                const error = new Error(
                    getEinvoiceErrorMessage(
                        responseData.error_code,
                        responseData.err_msg ||
                        responseData.error_msg ||
                        '更新會員資料失敗'
                    )
                )
                error.code = responseData.error_code
                throw error
            }

            // 重新取得會員資料以確保同步
            await dispatch('fetchMemberInfo')
        },
        async deleteAddress({ dispatch }, data) {
            const res = await deleteAddress(data)
            if (res?.data?.data?.msg === 'Failed') {
                throw res?.data?.data?.err_msg
            }
            await dispatch('fetchMemberInfo')
        },
        updateStoreData({ commit, state, getters }, data) {
            commit("setStoreData", { ...state.storeData, ...data });
            setAccessToken(getters.accessToken);
        },
        async fetchPointHistory({ commit, state }) {
            const sendData = {
                page: state.pointHistoryPage,
                page_size: 10
            }
            const res = await pointHistory(sendData)
            if (res?.data?.data?.msg === 'Failed') {
                throw res?.data?.data?.err_msg
            }
            let pointHistoryObject = { ...res.data?.data?.point_report_info }
            if (pointHistoryObject?.point_report_list) {
                let ls = []
                for (let item of pointHistoryObject.point_report_list) {
                    ls.push(new bounsModel(item))
                }
                pointHistoryObject.point_report_list = ls
            }
            console.log('pointHistoryObject', pointHistoryObject)
            commit('setPointHistory', { ...state.pointHistory, ...pointHistoryObject })
        },
        async fetchConsumptionInfo({ commit, state }) {
            const res = await getConsumptionInfo()
            if (res?.data?.data?.msg === 'Failed') {
                throw res?.data?.data?.err_msg
            }
            const consumptionInfo = res?.data?.data?.store_member_consumption_info
            commit('setConsumptionInfo', { ...state.consumptionInfo, ...consumptionInfo })
            console.log('consumptionInfo', state.consumptionInfo)
        },
        async joinMember({ dispatch }) {
            const res = await joinMember();
            if (res?.data?.data?.msg === 'Failed') {
                throw res?.data?.data?.err_msg;
            }
            dispatch('updateStoreData', res?.data?.data)
        },
        async changeStore({ dispatch }, storeCode) {
            const res = await storeChange(storeCode);
            if (res?.data?.data?.msg === 'Failed') {
                throw res?.data?.data?.err_msg;
            }
            dispatch('updateStoreData', res?.data?.data)

            // 店家切換時重置商品描述載入狀態，確保新店家的商品描述會重新載入
            dispatch('product/onProductDataUpdated', null, { root: true })

            // 新增：清除門市菜單資料（分類、商品、套餐）
            dispatch('storeMenu/clearData', null, { root: true })

            // 新增：清除店家服務清單，避免跨店時沿用上一間店的服務啟用狀態
            dispatch('basic/clearStoreServicesList', null, { root: true })

            // 新增：清除集點相關資料（兌換商品、集點卡資訊等）
            dispatch('point/clearPointData', null, { root: true })

        },
        async login({ dispatch, state }, data) {
            const res = await login(data);
            console.log('login res', res)
            if (res?.data?.data?.msg === 'Failed') {
                throw res?.data?.data?.err_msg;
            }
            dispatch('updateStoreData', res?.data?.data)
            console.log("login successful", state.storeData);
        }
    },
};
